export default {"src":"/_next/static/media/radio-unselected.3a46ce10.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};